<template>
  <div class="container-xl g-0 g-lg-2" :class="[containerClass]">
    <div class="row h-100 g-0 header-small" style="background-image: url('/images/temp/head-pr.png')">
      <div class="col d-flex align-items-end">
          <h1 class="mb-4 mx-4 mx-lg-0 mt-4" v-if="title" :class="[classProp]">
            {{ title }}
          </h1>
      </div>
      <div class="col-12 col-lg-5 col-md-6 " v-if="isLoggedIn">
        <div class="info-box d-flex justify-content-lg-end flex-column ms-auto mt-5">
          <h2 class="h3">
            Ważne informacje dla pasażerów
          </h2>
          <ul class="">
            <li><i class="bi bi-info-circle"></i> Aktualność dostępność pociągów PKP Intercity</li>
            <li><i class="bi bi-info-circle"></i> Limit 50 proc. miejsc siedzących w pociągach PKP Intercity</li>
            <li><i class="bi bi-info-circle"></i> Informacja dla podróżujących w relacjach międzynarodowych</li>
          </ul>
        </div>
      </div>
      <div class="col-12 col-lg-5 col-md-6 ic-form main-form" v-if="!isLoggedIn">
        <div class="">
          <form class="">
            <h2 class="h3">
              Logowanie do panelu dziennikarza
            </h2>
            <p class="small">
              Zalogowanie do panelu daje możliwość skorzystania ze zdjęć,
              materiałów wideo, a także materiałów graficznych i logotypów spółki,
            </p>
            <div class="w-75 mx-auto">
            <div class=" mb-2 input-group icon icon__person">
              <input type="text" class="form-control"  placeholder="Login" aria-label="Login">
            </div>
            <div class=" mb-2 input-group icon icon__key">
              <input type="password" class="form-control"  placeholder="Hasło" aria-label="Hasło">
            </div>
            <button type="submit" class="btn btn-warning mb-2 w-100">Zaloguj</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  name: 'section-header-small-pr',
  props:{
    'containerClass': {type: String, default: ''},
    'title': String,
    'classProp': {type: String, default: 'light bottom left' },
    'isLoggedIn': {type: Boolean, default: false }
  },
  components: {
  },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>